import { Icon } from '@eti/components';
import { vars, Text } from '@etg/wings';
import { css } from '@eti/styles';
import { rowIconWrapperStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const rowStyles = css`
  align-items: center;
  background-color: ${vars.colors.divider};
  display: table-row;
  font-size: 0.875rem;
  width: 100%;

  @media (max-width: 47.9375em) {
    border-top: 1px solid ${vars.colors.inputs.border};
    display: block;
    position: relative;
  }

  & > * {
    vertical-align: middle;

    svg {
      fill: ${vars.colors.decoration.neutral};
    }

    @media (min-width: 48em) {
      border-top: 1px solid ${vars.colors.inputs.border};
    }
  }
`;
const iconCellStyles = isAvailable => css`
  ${rowIconWrapperStyles};

  &::before {
    background-color: ${isAvailable === false ? vars.colors.decoration.secondary : vars.colors.signal.positive};
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 3px;

    @media (min-width: 48em) {
      width: 4px;
    }
  }

  html[dir='rtl'] & {
    &::before {
      left: auto;
      right: 0;
    }
  }
`;
const planeIconStyles = isOutbound => css`
  fill: ${vars.colors.decoration.neutral};
  height: 0.8rem;
  position: relative;
  top: 1px;
  transform: rotate(${isOutbound ? '45deg' : '225deg'});
  width: 0.8rem;

  html[dir='rtl'] & {
    transform: rotate(${isOutbound ? '225deg' : '45deg'});
  }

  @media (min-width: 48em) {
    height: 1rem;
    width: 1rem;
  }
`;
const originAndDestinationCellStyles = css`
  display: table-cell;
  font-size: 0.75rem;

  & div {
    display: inline;

    & span {
      font-weight: 700;
    }
  }

  html[dir='rtl'] & {
    text-align: right;
  }

  @media (min-width: 48em) {
    font-size: 0.875rem;
  }
`;
const SummarySegmentRow = ({
  destination,
  isAvailable,
  isOutbound,
  origin
}) => {
  return /*#__PURE__*/_jsxs("tr", {
    className: rowStyles,
    "data-testid": "seatMapSummarySegmentRow",
    children: [/*#__PURE__*/_jsx("td", {
      className: iconCellStyles(isAvailable),
      children: /*#__PURE__*/_jsx(Icon, {
        className: planeIconStyles(isOutbound),
        id: "plane-rotated"
      })
    }), /*#__PURE__*/_jsxs("td", {
      className: originAndDestinationCellStyles,
      colSpan: 4,
      children: [/*#__PURE__*/_jsxs(Text, {
        children: [origin.city, " ", /*#__PURE__*/_jsx("span", {
          children: origin.iata
        })]
      }), /*#__PURE__*/_jsx("span", {
        children: " \u2013 "
      }), /*#__PURE__*/_jsxs(Text, {
        children: [destination.city, " ", /*#__PURE__*/_jsx("span", {
          children: destination.iata
        })]
      })]
    })]
  });
};
export default SummarySegmentRow;
//# sourceMappingURL=SummarySegmentRow.js.map